import { RouteObject } from 'react-router-dom';
import { appPaths } from 'consts/paths/paths';
import { AutomaticCheckJournalAddPage } from 'pages/app/staff/journal/journalDetails/common/automaticCheckJournal/AutomaticCheckJournalAddPage/AutomaticCheckJournalAddPage';
import { AutomaticCheckJournalDetailsPage } from 'pages/app/staff/journal/journalDetails/common/automaticCheckJournal/AutomaticCheckJournalDetailsPage/AutomaticCheckJournalDetailsPage';
import { JournalNavigate } from 'navigation/routes/loggedApp/routes/staff/journal/components';
import { AbilityRoute } from '../../../../../../../AbilityRoute/AbilityRoute';
import { AppActions } from '../../../../../../../../types';
import { PERMISSIONS_NAME } from '../../../../../../../../consts/permissions/permissions';

export const automaticCheckJournalRoutes: RouteObject[] = [
    {
        path: appPaths.app.journals.specialJournalDetails.pickedJournal.automaticCheckJournal.add,
        element: (
            <AbilityRoute
                can={{
                    action: AppActions.DO_ACTION,
                    subject: PERMISSIONS_NAME.JOURNALS_AUTOMATIC_CHECKS,
                }}
            >
                <AutomaticCheckJournalAddPage journalType="SPECIAL" />
            </AbilityRoute>
        ),
    },
    {
        path: appPaths.app.journals.specialJournalDetails.pickedJournal.automaticCheckJournal
            .details.base,
        element: (
            <JournalNavigate
                to={appPaths.app.journals.specialJournalDetails.pickedJournal.inspections.base}
            />
        ),
    },
    {
        path: appPaths.app.journals.specialJournalDetails.pickedJournal.automaticCheckJournal
            .details.pickedAutomaticCheckJournal,
        element: (
            <AbilityRoute
                can={{
                    action: AppActions.DO_ACTION,
                    subject: PERMISSIONS_NAME.JOURNALS_AUTOMATIC_CHECKS,
                }}
            >
                <AutomaticCheckJournalDetailsPage journalType="SPECIAL" />
                ),
            </AbilityRoute>
        ),
    },
];
